import { render } from "./DashChartEnergy.vue?vue&type=template&id=5be86c8a&scoped=true&ts=true"
import script from "./DashChartEnergy.vue?vue&type=script&lang=ts"
export * from "./DashChartEnergy.vue?vue&type=script&lang=ts"

import "./DashChartEnergy.vue?vue&type=style&index=0&id=5be86c8a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be86c8a"]])

export default __exports__